import '../App.css';
import '../Css/Banner.css';
import NavBar from './Navbar/NavBar';

export default function Banner() {


  return (
    <div className='banner'>
        <div id='logoContainer'>
          <a href='#container' id='logoLink'><img id='logo' src='./images/logo/Logo Astraya Text Violet Transparent.png'></img></a>
          {/* <a href='#container'><div className='bannerName'>Astraya</div></a> */}
        </div>
        <NavBar />
    </div>

   
    
  );
}